export default "__VITE_ASSET__C6z91hjY__"